import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
import Git1 from '../img/git1.png';
import Git2 from '../img/git2.png';
export const KeyboardVSCode = () =>{


    return(
    
        <div id="articleContent" className="flex">
        
        <table>
        <thead><tr><th>Propriétés</th><th>Valeurs</th></tr></thead>
            <tr>
                <td>ALT + Z</td>
                <td>Activer et desactiver le retour à la ligne</td>
            </tr>
            <tr>
                <td>Ctrl + K + F</td>
                <td>Indentation et espacement automatique</td>
            </tr>
            <tr>
                <td>Ctrl + K et V</td>
                <td>Aperçu du .md (quand installation de Markdown Previeux Enhanced) </td>
            </tr>
            <tr>
                <td>Ctrl + K et C</td>
                <td>Mettre en commentaire</td>
            </tr>
            <tr>
                <td>Shift + ALT + flêche</td>
                <td>Dupliquer une ligne</td>
            </tr>
            <tr>
                <td>Ctrl + P</td>
                <td>Recherhcer au coeur de vs code</td>
            </tr>
            <tr>
                <td>Shift + TAB</td>
                <td>Retirer des tabulations</td>
            </tr>
            <tr>
                <td>Ctrl + Shift + F</td>
                <td>Rechercher dans tout le dossier</td>
            </tr>
        </table>
  </div>
    )
}
